var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 8.7373H0.511719L0.0634766 0.150391H3.10449L2.65625 8.7373ZM0.0283203 11.7432C0.0283203 11.1924 0.177734 10.8057 0.476562 10.583C0.78125 10.3604 1.14746 10.249 1.5752 10.249C1.99121 10.249 2.34863 10.3604 2.64746 10.583C2.95215 10.8057 3.10449 11.1924 3.10449 11.7432C3.10449 12.2705 2.95215 12.6514 2.64746 12.8857C2.34863 13.1201 1.99121 13.2373 1.5752 13.2373C1.14746 13.2373 0.78125 13.1201 0.476562 12.8857C0.177734 12.6514 0.0283203 12.2705 0.0283203 11.7432Z",
    fill: "#8A8A8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.faaffc1479daac63f73742902cea3e21.svg";
export { ForwardRef as ReactComponent };